import { useState } from 'react';

export default function Home() {
  const [selectedService, setSelectedService] = useState('free');

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white/35 backdrop-blur-sm shadow-sm absolute top-0 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <h1 className="text-5xl font-bold">
                <span className="text-blue-600">HVAC</span>
                <span className="text-red-600">2X</span>
                <span className="text-black">.COM</span>
              </h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#services" className="text-red-600 hover:text-red-700 font-medium text-lg">Services</a>
              <a href="#about" className="text-blue-600 hover:text-blue-700 font-medium text-lg">About</a>
              <a href="#contact" className="text-green-600 hover:text-green-700 font-medium text-lg">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary-50 to-white py-32 overflow-hidden min-h-[900px]"
               style={{
                 backgroundImage: `url('https://static.readdy.ai/image/a87a1c0d858b93ddab13e753841b9ae7/ae9214c3608fdba35ec1816ab48ae388.png')`,
                 backgroundSize: 'cover',
                 backgroundPosition: 'center center',
                 backgroundRepeat: 'no-repeat',
               }}>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-secondary-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-secondary-900 mb-4">Choose A Plan That Fits Your Growth Plan and Budget!</h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-8">
            {/* Free Tier */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-primary-100 hover:border-primary-300 transition-colors cursor-pointer flex flex-col"
                 onClick={() => setSelectedService('free')}>
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-gift-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-secondary-900 mb-2">Free Starter</h3>
                <div className="text-4xl font-bold text-primary-600 mb-2">$0</div>
                <p className="text-secondary-600">Perfect for getting started</p>
              </div>
              <ul className="space-y-4 mb-8 flex-grow">
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Free Go High Level Agency Account</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Free Skool Community Access Tuesdays at 5 p.m. Pacific
</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Basic Setup Support</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Community Resources for DIY Go Getters</span>
                </li>
              </ul>
              <button className="w-full bg-primary-600 text-white py-3 rounded-lg hover:bg-primary-700 transition-colors font-semibold whitespace-nowrap cursor-pointer mt-auto">
                Get Started Free
              </button>
            </div>

            {/* Credit Based */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-primary-300 hover:border-primary-400 transition-colors cursor-pointer relative flex flex-col"
                 onClick={() => setSelectedService('credit')}>
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-coins-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-secondary-900 mb-2">Credit System</h3>
                <div className="text-4xl font-bold text-primary-600 mb-2">$200</div>
                <p className="text-secondary-600">Per credit • Buy 1-5 credits</p>
              </div>
              <ul className="space-y-4 mb-8 flex-grow">
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Flexible project-based work</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Tell us what you want done</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Professional execution</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">No recurring fees</span>
                </li>
              </ul>
              <button className="w-full bg-primary-600 text-white py-3 rounded-lg hover:bg-primary-700 transition-colors font-semibold whitespace-nowrap cursor-pointer mt-auto">
                Buy Credits
              </button>
            </div>

            {/* Premium Level */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-primary-300 hover:border-primary-400 transition-colors cursor-pointer relative flex flex-col"
                 onClick={() => setSelectedService('premium')}>
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-semibold">Most Popular</span>
              </div>
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-primary-200 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-vip-crown-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-secondary-900 mb-2">Premium</h3>
                <div className="text-4xl font-bold text-primary-600 mb-2">$5000 + ad spend</div>
                <p className="text-secondary-600">Monthly Investment in Growth
</p>
              </div>
              <ul className="space-y-4 mb-8 flex-grow">
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">We Manage Your HVAC Marketing</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Dedicated Account Manager
</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Monthly strategy sessions</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Advanced automation setup</span>
                </li>
              </ul>
              <button className="w-full bg-primary-600 text-white py-3 rounded-lg hover:bg-primary-700 transition-colors font-semibold whitespace-nowrap cursor-pointer mt-auto">
                Go Premium
              </button>
            </div>

            {/* Hero Level */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-primary-300 hover:border-primary-400 transition-colors cursor-pointer flex flex-col"
                 onClick={() => setSelectedService('hero')}>
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-rocket-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-secondary-900 mb-2">Hero!</h3>
                <div className="text-4xl font-bold text-primary-600 mb-2">$10,000 + ad spend
</div>
                <p className="text-secondary-600">Per month • Full focus</p>
              </div>
              <ul className="space-y-4 mb-8 flex-grow">
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">We will 2X our team members so you can 2X your sales faster.
  
</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Accelerated plan to get you to 2X</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">Scott Rundle is your 24/7 2X Hero!</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-primary-600 mt-1 mr-3"></i>
                  <span className="text-secondary-700">We go all in to help you 2X faster.</span>
                </li>
              </ul>
              <button className="w-full bg-primary-600 text-white py-3 rounded-lg hover:bg-primary-700 transition-colors font-semibold whitespace-nowrap cursor-pointer mt-auto">
                Go Hero Level
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-secondary-900 mb-6">Meet Scott Rundle</h2>
              <p className="text-lg text-secondary-600 mb-6">
                As the founder of <span className="text-blue-600 font-semibold">HVAC</span><span className="text-red-600 font-semibold">2X</span><span className="text-black font-semibold">.com</span>, I've made it my mission to help HVAC owners grow from "just getting started" to becoming high-performing, scalable companies that can double sales without burning out.
              </p>
              <p className="text-lg text-secondary-600 mb-6">
                My team and I built <span className="text-blue-600 font-semibold">HVAC</span><span className="text-red-600 font-semibold">2X</span> around one simple idea: give every HVAC owner the tools to win—whether they want to do it themselves or have us build it for them.
              </p>
              <p className="text-lg text-secondary-600 mb-6">
                That's why we start you off with a Free Go High Level CRM & Marketing System, plus access to our weekly Skool class every Tuesday at 5 PM, where we teach everything from marketing to sales to operations.
              </p>
              <p className="text-lg text-secondary-600 mb-6">
                If you're a DIYer, you can stay free forever.
              </p>
              <p className="text-lg text-secondary-600 mb-6">
                If you want hands-on help, you can buy credits and have us build exactly what you need—websites, emails, text campaigns, funnels, social media, ads, automations, reputation building, follow-up systems, or anything else required to run and grow an HVAC business.
              </p>
              <p className="text-lg text-secondary-600 mb-6">
                When you're ready for speed and real growth, you can join our Premium or Hero Programs, where we build a full plan and timeline to help you double your sales.
              </p>
              <p className="text-lg text-secondary-600 mb-6 font-semibold">
                So pick your level.
              </p>
              <div className="space-y-4 mb-8">
                <p className="text-lg text-secondary-600">
                  <strong>Free</strong> - DIY and 2X your business on your time with our great tools and minimal support
                </p>
                <p className="text-lg text-secondary-600">
                  <strong>Credits</strong> - Buy some credits and give us a test job. Let us show you what we can do for you to 2X your sales
                </p>
                <p className="text-lg text-secondary-600">
                  <strong>Premium</strong> - Best Value - We work with you to figure out your best plan to 2x your business and we implement it over time.
                </p>
                <p className="text-lg text-secondary-600">
                  <strong>Hero</strong> - Accelerated Premium Program to get you to 2x about 2x the time. A more aggressive faster approach to get you to 2X.
                </p>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-linkedin-fill text-primary-600 text-xl"></i>
                </div>
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-twitter-fill text-primary-600 text-xl"></i>
                </div>
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-mail-fill text-primary-600 text-xl"></i>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/a87a1c0d858b93ddab13e753841b9ae7/1791df13ea8f7aa90e7f49a815063a4e.webp"
                alt="Scott Rundle - Founder of HVAC2X.com"
                className="w-full rounded-2xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-primary-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-secondary-900 mb-4">Why Choose <span className="text-blue-600">HVAC</span><span className="text-red-600">2X</span><span className="text-black">.com</span>?</h2>
            <p className="text-xl text-secondary-600">We're different from other digital marketing agencies</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-secondary-900 mb-2">No Long-Term Contracts</h3>
              <p className="text-secondary-600">We will earn and keep your business by helping you double sales.</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-secondary-900 mb-2">Results-Driven</h3>
              <p className="text-secondary-600">All of our efforts are geared toward helping you double your sales.</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-secondary-900 mb-2">Expert Team</h3>
              <p className="text-secondary-600">We have a dedicated team in all digital and print marketing professions to help you double your sales.</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-secondary-900 mb-2">Personal Support</h3>
              <p className="text-secondary-600">We are here for you. We are on the journey with you. We will help you double your sales.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary-600 to-primary-700 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to double your HVAC sales?</h2>
          <p className="text-xl mb-8 text-primary-100">
            Schedule a google meet with Scott and let's hear about your plan to double your sales. If you can't wait try Scott now at 951-640-3890.
          </p>
          <div className="flex justify-center">
            <a 
              href="https://calendly.com/scottrundle1/15min"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-8 py-4 rounded-lg hover:bg-white/10 transition-colors font-semibold whitespace-nowrap cursor-pointer"
            >
              Schedule a Call
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="bg-secondary-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-2xl font-bold mb-4">
                <span className="text-blue-500">HVAC</span>
                <span className="text-red-500">2X</span>
                <span className="text-white">.com</span>
              </h3>
              <p className="text-secondary-300 mb-6">
                We work with HVAC companies and our goal is to help you double sales. We will meet you where you are at and get a plan and timeline together to help you double your sales.
              </p>
              <div className="flex space-x-4">
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-primary-700 transition-colors">
                  <i className="ri-linkedin-fill text-white"></i>
                </div>
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-primary-700 transition-colors">
                  <i className="ri-twitter-fill text-white"></i>
                </div>
                <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-primary-700 transition-colors">
                  <i className="ri-facebook-fill text-white"></i>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <div className="space-y-2 text-secondary-300">
                <p className="flex items-center">
                  <i className="ri-mail-line mr-2 text-primary-400"></i>
                  ScottRundle1@gmail.com
                </p>
                <p className="flex items-center">
                  <i className="ri-phone-line mr-2 text-primary-400"></i>
                  951-640-3890
                </p>
                <p className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-primary-400"></i>
                  Lake Arrowhead, CA 92352
                </p>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Location</h4>
              <div className="w-full h-48 rounded-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26234.89!2d-117.1892!3d34.2439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c35c8b0c3e8f8f%3A0x8e8e8e8e8e8e8e8e!2sLake%20Arrowhead%2C%20CA%2092352!5e0!3m2!1sen!2sus!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Lake Arrowhead, CA 92352"
                ></iframe>
              </div>
            </div>
          </div>

          <div className="border-t border-secondary-700 mt-12 pt-8 text-center text-secondary-400">
            <p>&copy; 2024 <span className="text-blue-400">HVAC</span><span className="text-red-400">2X</span><span className="text-white">.com</span>. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
